import * as React from 'react';
import '../../../styles/DashboardPage.css';
import { useFetch } from '../../../hooks/useFetch';
import { getJustProperties, Property } from '../../../api/Property';
import { useState, useEffect, useMemo } from 'react';
import * as moment from 'moment';
import { DateRangePicker } from 'react-dates';
import {
    Prospect,
    getAllProspectsExportData,
    getPropertyProspectDataExport
} from '../../../api/Prospect';
import { exportAllProspectsData } from '../../../utilities/exportLog';
import { userIsSystemAdmin, userIsCompanyAdmin, userIsPropertyAdmin } from '../../../utilities/identity';
import RecentActivityContainer from './dashboardWidgets/RecentActivityContainer';
import SearchableDropdownClear from '../../common/SearchableDropdownClear';
let exportIcon = require('../../../images/export_icon.png');

export const DashboardPage = () => {
    const { data: properties, loading } = useFetch(getJustProperties, [], [] as Property[]);
    const [selectedPropertyIds, setPropertyIds] = useState<number[]>([]);
    const [startDate, setStartDate] = useState<moment.Moment>(moment());
    const [endDate, setEndDate] = useState<moment.Moment>(moment().add(7, 'days'));
    const [datePickerFocus, setDatePickerFocus] = useState<'startDate' | 'endDate' | null>(null);
    const [excludedProspects, setExcludedProspects] = useState<Prospect[]>([]);
    const [loadingExport, setLoadingExport] = useState(false);
    const [propertyLoadExport, setPropertyLoadExport] = useState(false);

    useEffect(() => {
        if (selectedPropertyIds.length === 0 && properties && properties.length > 0) {
            setPropertyIds([properties[0].id]);
        }
    });

    const handleExportAllData = async () => {
        setLoadingExport(true);

        await getAllProspectsExportData(startDate.toISOString(), endDate.toISOString()).then(r => {
            if (r.data !== undefined) {
                exportAllProspectsData(r.data, 'tour24 All Prospects Data Export');
            }
        });
        setLoadingExport(false);
    };

    const handleExportPropertyData = async () => {
        setPropertyLoadExport(true);


        await getPropertyProspectDataExport(startDate.toISOString(), endDate.toISOString(), selectedPropertyIds[0]).then(r => {
            if (r.data !== undefined) {
                exportAllProspectsData(r.data, 'tour24 Property Prospects Data Export');
            }
        });
        setPropertyLoadExport(false);
    };

    var selectedProperty = useMemo(() => {
        return properties.find(p => p.id === selectedPropertyIds[0]);
    }, [selectedPropertyIds[0]]);

    return (
        <>
            <header>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div className="dashboard-container">
                        <h2 style={{ paddingBottom: '12px' }}>Dashboard</h2>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'end' }}>
                        <div style={{ display: 'flex', flexDirection: 'row', gap: '30px', }}>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <p style={{ fontWeight: 'bold', marginBottom: '2px' }}>Date</p>
                                <div className="form-date-picker-range">
                                    <DateRangePicker
                                        startDate={startDate ? moment(startDate) : null}
                                        endDate={endDate ? moment(endDate) : null}
                                        onDatesChange={(arg: {
                                            startDate: moment.Moment | null;
                                            endDate: moment.Moment | null;
                                        }) => {
                                            if (arg.startDate) {
                                                setStartDate(arg.startDate);
                                            }
                                            if (arg.endDate) {
                                                setEndDate(arg.endDate);
                                            }
                                        }}
                                        focusedInput={datePickerFocus}
                                        onFocusChange={focusedOptions => setDatePickerFocus(focusedOptions)}
                                        startDateId="prospects-start-date"
                                        endDateId="prospects-end-date"
                                        showClearDates={true}
                                        isOutsideRange={() => false}
                                        hideKeyboardShortcutsPanel={true}
                                    />
                                </div>
                            </div>
                            {properties &&
                                (properties.length === 1 ? (
                                    <div className="text-right">{properties[0].name}</div>
                                ) : (
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <p style={{ fontWeight: 'bold', marginBottom: '2px' }}>Property</p>
                                         <SearchableDropdownClear
                                            heading={'Select Property'}
                                            listItems={!loading && properties
                                                ? properties.map(p => ({
                                                    value: p.id,
                                                    name: p.name
                                                }))
                                                : []}
                                            selectedId={selectedPropertyIds[0]}
                                            setSelectedId={(val: number | null) => {
                                                if (typeof val === 'number') {
                                                    setPropertyIds([val]);
                                                }
                                            }}
                                        />
                                    </div>
                                ))}
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', gap: '12px' }}>
                        {userIsSystemAdmin() && (
                            <div>
                                {loadingExport ? (
                                    <label className="button-disabled">Loading Export...</label>
                                ) : (
                                    <div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
                                        <label
                                            className="button-available"
                                            style={{ fontWeight: 'bold', color: '#33ADFF' }}
                                            onClick={() => handleExportAllData()}
                                        >
                                            Export All Properties Data
                                        </label>
                                        <img style={{ height: '20px', width: '20px' }} src={exportIcon} />
                                    </div>
                                )}
                            </div>
                        )}
                        {(userIsSystemAdmin() || userIsCompanyAdmin() || userIsPropertyAdmin()) && (
                            <div>
                                {propertyLoadExport ? (
                                    <label className="button-disabled">Loading Export...</label>
                                ) : (
                                    <div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
                                        <label
                                            className="button-available"
                                            style={{ fontWeight: 'bold', color: '#33ADFF' }}
                                            onClick={() => handleExportPropertyData()}
                                        >
                                            Export Property Data
                                        </label>
                                        <img style={{ height: '20px', width: '20px' }} src={exportIcon} />
                                    </div>
                                )}
                            </div>
                        )}
                        </div>
                    </div>
                </div>
            </header>
            <div className="dashboard" style={{ marginTop: '20px' }}>
                <RecentActivityContainer
                    selectedProperty={selectedProperty}
                    startDate={startDate}
                    endDate={endDate}
                    excludedProspects={excludedProspects}
                    setExcludedProspects={setExcludedProspects}
                />
            </div>
        </>
    );
};



// WEBPACK FOOTER //
// ./src/components/pages/admin/DashboardPage.tsx